import { render } from "./DashboardShortcut.vue?vue&type=template&id=f1bd9a32&scoped=true&lang=pug"
import script from "./DashboardShortcut.vue?vue&type=script&lang=js"
export * from "./DashboardShortcut.vue?vue&type=script&lang=js"

import "./DashboardShortcut.vue?vue&type=style&index=0&id=f1bd9a32&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bd9a32"]])

export default __exports__